import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { TrashIcon } from '@heroicons/react/24/solid';

import { Button as ButtonV2, Heading, Modal, ModalContent } from '@restworld/ui-ds-base';

interface DeleteJobPositionDraftModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function DeleteJobPositionDraftModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: DeleteJobPositionDraftModalProps) {
  const { t } = useTranslation('job-positions-page');

  const handleConfirm = useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  const titleEl = (
    <Heading color="neutral" align="center" className="leading-[30px] px-4 sm:px-0">
      {t('delete_draft_confirmation_title')}
    </Heading>
  );

  const footerEl = (
    <div className="flex flex-col justify-center items-center gap-4 w-full">
      <ButtonV2
        onClick={handleConfirm}
        fullwidth
        loading={isLoading}
        StartIcon={TrashIcon}
        variant="secondary-danger"
        disabled={isLoading}
      >
        {t('delete_draft_confirm_button')}
      </ButtonV2>
      <ButtonV2 variant="tertiary" fullwidth onClick={() => onClose()} disabled={isLoading}>
        {t('delete_draft_cancel_button')}
      </ButtonV2>
    </div>
  );

  return (
    <Modal open={isOpen} onOpenChange={(v) => !v && onClose()}>
      <ModalContent className="w-full max-w-[640px] lg:max-w-screen-sm" title={titleEl} footer={footerEl}>
        <div className="flex flex-col justify-center items-center gap-5 w-full text-center mt-6">
          <Heading size={5} weight="medium" color="neutral" className="whitespace-pre-line">
            {t('delete_draft_confirmation_description')}
          </Heading>
        </div>
      </ModalContent>
    </Modal>
  );
}

export default DeleteJobPositionDraftModal;
